import { Alert, AlertDescription } from "@/components/atoms/alert";
import ProfileLoadingScreen from "@/components/atoms/profileLoadingScreen";
import {
  SESSION_LOADING_SIGNING_IN,
  SESSION_LOADING_UNABLE_TO_SIGN_IN,
} from "@/constants/uiCopy/sessionLoading";
import { isCognitoOAuthReturnUrl } from "@/lib/auth/cognitoOAuthReturnUrl";
import {
  SESSION_END_REASON,
  loadSessionEndReason,
} from "@/lib/session/sessionEndReasonStorage";

/**
 * After the backend rejected a valid token and the user was logged out, true
 * while the app heads back to sign-in. False once Cognito returns with the new
 * sign-in (`?code=`), even though the reason is only cleared when it completes.
 */
const isHeadingBackAfterRejectedToken = (): boolean =>
  loadSessionEndReason() === SESSION_END_REASON.TOKEN_REJECTED &&
  !isCognitoOAuthReturnUrl();

/** Full-viewport startup screen. */
const AppLoadingScreen = () => (
  <ProfileLoadingScreen>
    {isHeadingBackAfterRejectedToken() ? (
      <Alert variant="warning" className="w-auto">
        <AlertDescription>{SESSION_LOADING_UNABLE_TO_SIGN_IN}</AlertDescription>
      </Alert>
    ) : (
      <Alert role="status" className="w-auto">
        <AlertDescription>{SESSION_LOADING_SIGNING_IN}</AlertDescription>
      </Alert>
    )}
  </ProfileLoadingScreen>
);

export default AppLoadingScreen;
